import urlJoin from 'url-join'

export const leadQueueSection = '/lead-queue/'

/**
 * The intake queues this screen hosts. Only the import quarantine is left —
 * the merge-review queue was removed with automatic linking — but the screen
 * keeps its tab shape so `/lead-queue/quarantine` links stay stable and a
 * future queue slots in without new routes.
 */
export enum LeadQueueTab {
  quarantine = 'quarantine',
}

/** Tab order. With one queue the strip is hidden; the order still drives the landing tab. */
export const LEAD_QUEUE_TAB_ORDER = [LeadQueueTab.quarantine] as const

export const leadQueueUrl = (tab: LeadQueueTab): string => urlJoin(leadQueueSection, tab)
